import { render, staticRenderFns } from "./EmailData.vue?vue&type=template&id=0d566233&scoped=true"
import script from "./EmailData.vue?vue&type=script&lang=js"
export * from "./EmailData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d566233",
  null
  
)

export default component.exports